import wretch from 'wretch';

export const apiUrl = import.meta.env.VITE_API_URL;
export const apiLocation = 'https://api-adresse.data.gouv.fr/search';

export const api = wretch(apiUrl, { credentials: 'include', mode: 'cors' })
  .errorType('json')
  .resolve((r) => r.json());
